/* eslint-disable import/no-cycle */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { DateRange, DropDown, Icon } from 'ui/atoms';
import theme from 'ui/theme';

//import { REMOVE_FILTER } from '../../../redux/slices/dashboard';
import { Divider, DropdownWrapper, IconWrapper, MultiDropdownWrapper } from './style';

const MultiDropdown = ({
  dropdownList,
  onSubmit,
  width,
  height,
  showDropdowns = true,
  onSelect,
  maxWidthControls,
  selectEndDateError
}) => {
  const [selectedOptions, setSelectedOptions] = useState();

  const [active, setActive] = useState();

  const onDropdownChange = (selected, name, cb) => {
    setSelectedOptions(prev => ({ ...prev, [name]: selected }));
    if (cb) {
      cb(name, selected?.value || selected);
    }
  };

  const removeFilterFromStore = name => {};

  const removeFilter = name => {
    setSelectedOptions(prev => {
      delete prev?.[name];
      return { ...prev };
    });
    removeFilterFromStore(name);
  };

  const onEnter = () => {
    setActive();
    if (onSubmit) {
      onSubmit(selectedOptions);
    }
  };

  const onMenuOpen = name => {
    setActive(name);
  };

  const onMenuClose = () => {
    setActive();
  };

  return (
    <MultiDropdownWrapper
      width={width}
      height={height}
      showDropdowns={showDropdowns}
    >
      {showDropdowns ? (
        <DropdownWrapper onClick={onSelect} maxWidthControls={maxWidthControls}>
          {dropdownList.map(
            (
              {
                index,
                options,
                placeholder,
                menuWidth,
                isMulti,
                detachedOptions,
                checkBoxMenu,
                name,
                resetSelection,
                values,
                period,
                onChange,
                defaultIndex
              },
              rowIndex
            ) => (
              <React.Fragment key={`${index}-${placeholder}-${rowIndex}`}>
                {period ? (
                  <>
                    <DateRange
                      key={index}
                      placeholder={placeholder}
                      values={values}
                      onChange={selected => {
                        onDropdownChange(selected, name, onChange);
                      }}
                      resetSelection={resetSelection}
                      isClearable
                      onReset={propName => {
                        removeFilter(propName);
                      }}
                      selectEndDateError={selectEndDateError}
                    />
                    {rowIndex !== dropdownList.length - 1 && <Divider />}
                  </>
                ) : (
                  <>
                    <DropDown
                      key={index}
                      options={options}
                      placeholder={placeholder}
                      isMulti={isMulti}
                      onChange={selected =>
                        onDropdownChange(selected, name, onChange)
                      }
                      maxMenuHeight={320}
                      menuWidth={menuWidth}
                      checkBoxMenu={checkBoxMenu}
                      isClearable={false}
                      detachedOptions={detachedOptions}
                      menuIsOpen={active === name}
                      onMenuOpen={() => onMenuOpen(name)}
                      onMenuClose={onMenuClose}
                      resetSelection={resetSelection}
                      defaultIndex={defaultIndex}
                    />
                    {rowIndex !== dropdownList.length - 1 && <Divider />}
                  </>
                )}
              </React.Fragment>
            )
          )}
        </DropdownWrapper>
      ) : null}
      <IconWrapper onClick={onEnter}>
        <Icon type="icon-enter" size="28" color={theme().colors.white} />
      </IconWrapper>
    </MultiDropdownWrapper>
  );
};

MultiDropdown.defaultProps = {
  selectEndDateError: false
};

MultiDropdown.propTypes = {
  dropdownList: PropTypes.array,
  onSubmit: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  showDropdowns: PropTypes.bool,
  onSelect: PropTypes.func,
  maxWidthControls: PropTypes.string,
  selectEndDateError: PropTypes.bool
};

export default connect(null, dispatch => ({
  //removeFilterFromStore: payload => dispatch(REMOVE_FILTER(payload))
}))(MultiDropdown);
